import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(roomId, listingId, price_import, lang) {
    const response = await api.fetch(`/api/v2/airbnb/connect/`, {
      method: 'POST',
      body: JSON.stringify({
        id_room: roomId,
        id_listing: listingId,
        price_import: price_import,
        lang: lang,
      }),
    })
    return await handleResponse(response)
  }
}
